// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type UnSyncedFutureEventsQueryVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type UnSyncedFutureEventsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminQueries' }
      & { unSyncedEvents: Array<(
        { __typename?: 'EventModel' }
        & Pick<PrivateSchemaTypes.EventModel, 'id'>
      )> }
    )> }
  )> }
);

export type PushUnSyncedEventsMutationVariables = PrivateSchemaTypes.Exact<{ [key: string]: never; }>;


export type PushUnSyncedEventsMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { organisation?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'OrganisationModelAsAdminMutations' }
      & { pushUnSyncedEventsToCalendars: Array<(
        { __typename?: 'EventModel' }
        & Pick<PrivateSchemaTypes.EventModel, 'id'>
      )> }
    )> }
  )> }
);


export const UnSyncedFutureEventsDocument = gql`
    query unSyncedFutureEvents {
  admin {
    organisation {
      unSyncedEvents {
        id
      }
    }
  }
}
    `;

/**
 * __useUnSyncedFutureEventsQuery__
 *
 * To run a query within a React component, call `useUnSyncedFutureEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnSyncedFutureEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnSyncedFutureEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnSyncedFutureEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UnSyncedFutureEventsQuery, UnSyncedFutureEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnSyncedFutureEventsQuery, UnSyncedFutureEventsQueryVariables>(UnSyncedFutureEventsDocument, options);
      }
export function useUnSyncedFutureEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnSyncedFutureEventsQuery, UnSyncedFutureEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnSyncedFutureEventsQuery, UnSyncedFutureEventsQueryVariables>(UnSyncedFutureEventsDocument, options);
        }
export type UnSyncedFutureEventsQueryHookResult = ReturnType<typeof useUnSyncedFutureEventsQuery>;
export type UnSyncedFutureEventsLazyQueryHookResult = ReturnType<typeof useUnSyncedFutureEventsLazyQuery>;
export type UnSyncedFutureEventsQueryResult = Apollo.QueryResult<UnSyncedFutureEventsQuery, UnSyncedFutureEventsQueryVariables>;
export const PushUnSyncedEventsDocument = gql`
    mutation pushUnSyncedEvents {
  admin {
    organisation {
      pushUnSyncedEventsToCalendars {
        id
      }
    }
  }
}
    `;
export type PushUnSyncedEventsMutationFn = Apollo.MutationFunction<PushUnSyncedEventsMutation, PushUnSyncedEventsMutationVariables>;

/**
 * __usePushUnSyncedEventsMutation__
 *
 * To run a mutation, you first call `usePushUnSyncedEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushUnSyncedEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushUnSyncedEventsMutation, { data, loading, error }] = usePushUnSyncedEventsMutation({
 *   variables: {
 *   },
 * });
 */
export function usePushUnSyncedEventsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PushUnSyncedEventsMutation, PushUnSyncedEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PushUnSyncedEventsMutation, PushUnSyncedEventsMutationVariables>(PushUnSyncedEventsDocument, options);
      }
export type PushUnSyncedEventsMutationHookResult = ReturnType<typeof usePushUnSyncedEventsMutation>;
export type PushUnSyncedEventsMutationResult = Apollo.MutationResult<PushUnSyncedEventsMutation>;
export type PushUnSyncedEventsMutationOptions = Apollo.BaseMutationOptions<PushUnSyncedEventsMutation, PushUnSyncedEventsMutationVariables>;